<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="130px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="人员姓名" prop="name">
              <el-input
                clearable
                v-model="form.name"
                placeholder="人员姓名"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="phone">
              <el-input
                clearable
                v-model="form.phone"
                placeholder="联系方式"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报名时间" prop="registerTime">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.registerTime"
                type="datetime"
                placeholder="请选择报名时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-for="(item, itemKey, index) in dicFields" :key="itemKey" :span="12">
            <el-form-item :label="item.dictValue" :prop="itemKey">
              <el-select
                v-model="form[itemKey]"
                placeholder="请选择"
                clearable
                style="width: 100%;"
              >
                <el-option
                  v-for="option in item.options"
                  :key="option.dictKey"
                  :label="option.dictValue"
                  :value="option.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                maxlength="200"
                type="textarea"
                placeholder="请输入描述"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
    dicFields: {
      default: {}
    },
  },
  data() {
    return {
      projectList: [],

      form: {
        name: '',
        registerTime: '',
        phone: '',
        remark: '',
        joinCommunity: '',
        registerProject: '',
      },
      formRules: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'change' }],
        registerTime: [{ required: true, message: '报名时间不能为空', trigger: 'change' }],
        phone: [{ required: true, message: '联系方式不能为空', trigger: 'change' }],
        joinCommunity: [{ required: true, message: '请选择', trigger: 'change' }], // 2个自定义的字段
        registerProject: [{ required: true, message: '请选择', trigger: 'change' }], // 2个自定义的字段
      },
      matetialList: [],
      nursinghomeIdList: [],
      userList: []
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    initData() {
      if (this.model === 'add') {
      } else {
        this.form = Object.assign({}, this.row);
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if (this.model === 'add') {
            this.$emit('submit', this.form);
          } else {
            this.row.name = this.form.name;
            this.row.registerTime = this.form.registerTime;
            this.row.phone = this.form.phone;
            this.row.remark = this.form.remark;
            if (this.form.hasOwnProperty('joinCommunity')) {
              this.row.joinCommunity = this.form.joinCommunity;
            }
            if (this.form.hasOwnProperty('registerProject')) {
              this.row.registerProject = this.form.registerProject;
            }            
            this.$emit('cancle');
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped lang="scss">
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
::v-deep {
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-form-item__content {
    padding-bottom: 15px;
  }
  .el-form-item__error {
    position: absolute;
    bottom: 0;
    top: auto;
  }
}
</style>
